import { IQosEndSchema } from '../events/Qos.event';

/**
 * @public
 */
export function mergeQosEndSchema(endData: IQosEndSchema, ...moreEndData: Partial<IQosEndSchema>[]): IQosEndSchema {
  return moreEndData.reduce((previousEndData: IQosEndSchema, currentEndData: Partial<IQosEndSchema>) => {
    return {
      ...previousEndData,
      ...currentEndData,
      ...(previousEndData.extraMetrics || currentEndData.extraMetrics ? {
        extraMetrics: {
          ...(previousEndData.extraMetrics || {}),
          ...(currentEndData.extraMetrics || {})
        }
      } : {}),
      ...(previousEndData.extraData || currentEndData.extraData ? {
        extraData: {
          ...(previousEndData.extraData || {}),
          ...(currentEndData.extraData || {})
        }
      } : {})
    };
  }, endData);
}
